module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-greenery-3-cb8aba8dba33fb47621ed9b2c1504c69.webp";